module.exports = __webpack_public_path__ + "static/media/website-security-management2.2b777d68.png";